import type { RouteRecordRaw, Router } from 'vue-router'

const AccidentRoutes: RouteRecordRaw = {
  path: '/claim/accident',
  name: 'AccidentModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'AccidentMainRoute',
      component: () => import('./views/AccidentView.vue'),
      meta: {
        title: 'accident.accidentClaims',
      },
    },
    {
      path: 'create',
      name: 'AccidentCreateRoute',
      component: () => import('./views/AccidentUpsertView.vue'),
      meta: {
        title: 'accident.createAccident',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accidentId',
      name: 'AccidentEditRoute',
      component: () => import('./views/AccidentUpsertView.vue'),
      meta: {
        title: 'accident.editAccident',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accidentId',
      name: 'ViewAccidentRoute',
      component: () => import('./views/SingleAccidentView.vue'),
      meta: {
        title: 'accident.ViewAccident',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(AccidentRoutes)
}
